import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useDraftServiceNameOptions } from '~/hooks/reactQuery/queries/useServiceNameOptions';
import { useLocaleKeys } from '~/i18n';
import { useDraftsChipConnector } from './DraftsAiSearchChips/draftsChipConnector';
import { DRAFTS_SERVICE_FIELD_GRAMMAR } from './draftsServiceFields';
export const useDraftsServiceGrammar = ()=>{
    const { t } = useLocaleKeys('proposal.draftsDashboard.aiSearch');
    const connector = useDraftsChipConnector();
    return _object_spread_props(_object_spread({}, DRAFTS_SERVICE_FIELD_GRAMMAR), {
        stateFields: [],
        useNameOptions: useDraftServiceNameOptions,
        texts: t,
        connector,
        biPrefix: 'drafts_ai_search_chip_service',
        summaryBi: {
            toggleQuantifier: 'drafts_ai_search_chip_toggle_services_quantifier',
            remove: 'drafts_ai_search_chip_remove_services'
        },
        toEntityPredicate: (predicate)=>predicate
    });
};
